import request from 'superagent';
import s3upload from './s3';
import clupload from './cloudinary';

/**
 * Post a file to a specific url
 *
 * @param file
 * @param url
 * @param headers
 * @param fields
 * @param onProgress
 */
const postFile = (file, url, headers, fields, onProgress) =>
  new Promise((resolve, reject) => {
    request
      .post(url)
      .set(headers)
      .field(fields)
      .attach('file', file)
      .on('progress', e => {
        const progress = e.percent / 100;
        if (!Number.isNaN(progress)) {
          onProgress(progress);
        }
      })
      .then(response => {
        if (response.ok) {
          resolve(response.body);
        } else {
          reject(`Got ${response.status} when uploading to ${url}`);
        }
      })
      .catch(reject);
  });

/**
 * Upload the provided file to the appropriate upload backend
 *
 * @param file: a file object
 * @param uploadData: contains the upload url and the upload params
 * @param progressCallback: function to call with the progress value when it changes
 *
 * Returns a promise that will resolve with extended upload information (type, url, size, etc...)
 */
const upload = (file, uploadData, progressCallback) =>
  new Promise((resolve, reject) => {
    let uploadAction;

    switch (uploadData.uploadService) {
      case 's3':
        uploadAction = s3upload;
        break;
      case 'cl':
        uploadAction = clupload;
        break;
      default:
        reject(`Unknown upload backend ${uploadData.uploadService}`);
    }

    uploadAction(postFile, file, uploadData, progressCallback)
      .then(uploadResult => {
        resolve({
          type: uploadData.type,
          mimeType: uploadData.mimeType,
          service: uploadData.uploadService,
          size: file.size,
          ...uploadResult,
        });
      })
      .catch(reject);
  });
export default upload;
